import { DateConverter } from 'src/app/core/services/mapper/converters';
import * as moment from 'moment';

export class InteractionAccueil {
    static jsonMap = {
        auteurMiseAJour: { key: 'auteurMiseAJour', optional: true, default: '' },
        sujet: { key: 'sujet', optional: true, default: '' },
        dateInteraction: { key: 'dateInteraction', converter: new DateConverter(), optional: true }
    };

    public auteurMiseAJour: string;
    public sujet: string;
    public dateInteraction: moment.Moment;
}
